import { LineInterface } from '../../models/line.interface';

export interface LineInterfaceState {
  line: LineInterface;
}

export const initialLineState: LineInterfaceState = {
  line: null
};
